import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import { AppNoInfo } from '@/layout/AppComponents';
import { axiosPath } from '../../../../../../routing/helpers/router';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import ResponsibleSelect from '../../../../../components/form/Selects/ResponsibleSelect';
import Translator from '../../../../../components/helpers/Translator';
import useIsMounted from '../../../../../components/hooks/useIsMounted';
import ResourceObligationCard from './ResourceObligationCard';

export default function ResourceManagerTab(props) {
  const { plantObligationID } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const resourceObligations = useSelector(
    (s) => s.currentPage?.resourceObligationTabs?.[plantObligationID]
  );
  const [isLoading, setIsLoading] = useState(false);

  // > LOAD RESOURCE MANAGER TAB
  useEffect(() => {
    setIsLoading(true);
    (async () => {
      try {
        const response = await axios.post(
          axiosPath("api_r_user_module_legalCompliance_resourceManager_tab"),
          {
            moduleBridgeHex,
            plantHex,
            plantObligationID,
          }
        );
        if (isMounted.current) {
          dispatch(
            currentPageAction.change('resourceObligationTabs', {
              [plantObligationID]: response.data,
            })
          );
          setIsLoading(false);
        }
      } catch (err) {}
    })();
  }, []);
  // < LOAD RESOURCE MANAGER TAB

  if (isLoading) return <AppNoInfo minHeight={300} />;

  return (
    <ResourceManagerTabContainer>
      <ul className="list-group">
        {resourceObligations !== undefined &&
          resourceObligations?.map((ro, i) => (
            <ResourceObligationCard
              key={ro.id}
              resourceObligation={ro}
              plantObligationID={plantObligationID}
            />
          ))}
      </ul>
    </ResourceManagerTabContainer>
  );
}

const ResourceManagerTabContainer = styled.div`
  height: 400px;
  tr > td {
    padding: 4px;
    font-size: 12px;
    & > div {
      height: 20px;
      overflow-y: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }
  }
`;
